import Cookies from 'js-cookie';
import window from 'ember-window-mock';
// @ts-expect-error -- file is not typed
import ENV from 'receivable-invoices-js/config/environment';

const COOKIE_MAX_AGE_DAYS = 366;

/**
 * Determines the cookie domain based on the deploy target.
 * Returns null for local development (which uses the current domain).
 */
function getCookieDomain(): string | undefined {
  const env = ENV as { deployTarget?: string; environment?: string };
  const runningOnSubdomain = window.location.href.includes('.dev.qonto.co');
  const isAuthenticationShareable = env.environment === 'development' && runningOnSubdomain;

  if (env.deployTarget === 'staging') {
    return '.qonto.co';
  }
  if (env.deployTarget === 'production') {
    return '.qonto.com';
  }
  if (isAuthenticationShareable) {
    return '.dev.qonto.co';
  }
  return undefined;
}

/**
 * Determines if the secure flag should be set on the cookie.
 * Returns true for non-development environments.
 */
function isSecureCookie(): boolean {
  const env = ENV as { environment?: string };
  return env.environment !== 'development';
}

/**
 * Gets the device ID from the deviceId cookie.
 * If no device ID exists, one is created and stored in the cookie.
 *
 * @returns The device ID
 */
export function getDeviceId(): string {
  let deviceId = Cookies.get('deviceId');

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    const domain = getCookieDomain();
    Cookies.set('deviceId', deviceId, {
      secure: isSecureCookie(),
      ...(domain && { domain }),
      expires: COOKIE_MAX_AGE_DAYS,
    });
  }

  return deviceId;
}
